import React from "react";
import { Box, Label, theme } from "Application";
import { DetailsList, MentorBox } from "./SessionReport.styles";
import { isEmptyOrWhitespace } from "@shoothill/core";
import { IStudentSessionReportViewModel } from "Views/Students/Student/StudentReports/Form/Interfaces/IStudentSessionReportViewModel";
import { ThemedEditSelect } from "Styles/ThemedPrimitives/Style1/ThemeEditSelect";
import { observer } from "mobx-react-lite";
import { Else, Show } from "Components/General/Show";

export const SessionReportDetails: React.FC<{ viewModel: IStudentSessionReportViewModel }> = observer(({ viewModel }) => (
    <Box borderBottom="1px solid #D4D4D4" gap="20px">
        <DetailsList mb={"22px"} display={"grid"}>
            <Box display={"flex"} alignItems={"center"} style={{ gap: "10px" }}>
                <Label fontStyle="label">Student name:</Label>
                <Label fontStyle={"p"} color={"black"}>
                    {viewModel.model.student.fullName}
                </Label>
            </Box>
            <Box display={"flex"} alignItems={"center"} style={{ gap: "10px" }}>
                <Label fontStyle="label">Mentor name:</Label>
                <Show if={viewModel.showMentorSelect && !viewModel.model.id}>
                    <MentorBox>
                        <ThemedEditSelect
                            placeholder={"Please select"}
                            command={viewModel.updateMentorCommand}
                            style={{ width: "200px" }}
                            options={viewModel.mentorKeyValuePairs}
                            value={() => viewModel.getValue("mentorId")}
                            validationMessage={() => viewModel.getError("mentorId")}
                        />
                    </MentorBox>
                    <Else>
                        <Label>{viewModel.model.sessionMentor.fullName}</Label>
                    </Else>
                </Show>
            </Box>
        </DetailsList>
        <Box mb={"22px"}>
            <Label fontStyle={"label"} color={"black"}>
                Emotional Regulation Mentoring Programme:
            </Label>
            <Label fontStyle={"p"} color={"black"}>
                {viewModel.emotionalRegulationMentoringProgramme}
            </Label>
        </Box>
    </Box>
));
